import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const requiredTrimmed: ValidatorFn = (
  control: AbstractControl<string>
): ValidationErrors | null => {
  return control.value.trim().length > 0 ? null : { requiredTrimmed: true };
};
